import { get, isEmpty, isUndefined, startsWith, set, unset } from 'lodash'
import produce from 'immer'

import { getDefaultSegment, sanitizeSegmentOutput } from 'components/SegmentSelector/segment-service'
import { DEFAULT_USER_TYPE } from 'components/SegmentSelector/UserTypeSelector'
import api from 'common/api'
import { SCHEDULED_FIELD_NAME, getDefaultScheduledDate } from './helpers'

export const DEFAULT_LINK_LABEL = 'Learn More'

export const ingestMessage = (record, userType) =>
  !isEmpty(record) && isEmpty(record.Segment)
    ? produce(record, (draft) => {
        draft.Segment = getDefaultSegment(get(draft, 'Trigger'), userType)
        return draft
      })
    : record

const setSegment = (draft, segment, trigger) => {
  const updatedSegment = sanitizeSegmentOutput(segment, trigger)
  if (isUndefined(updatedSegment)) {
    unset(draft, 'SegmentId')
    unset(draft, 'Segment')
  } else {
    set(draft, 'Segment', updatedSegment)
  }
}

const setLink = (message, link, linkLabel) => {
  if (!startsWith(link, 'http')) {
    set(message, 'Link', 'http://' + link)
  }
  const label = isEmpty(linkLabel) ? DEFAULT_LINK_LABEL : linkLabel
  set(message, 'LinkLabel', label)
}

const prepareForSave = (message, Scid) =>
  produce(message, (draft) => {
    const { Segment, Link, Trigger, LinkLabel } = draft
    draft.Scid = Scid
    setSegment(draft, Segment, Trigger)
    if (!isEmpty(Link)) {
      setLink(draft, Link, LinkLabel)
    }
  })

export const getDefaultMessage = (Trigger) => ({
  Subject: '',
  Message: '',
  Link: '',
  Trigger,
  IsDraft: true,
  LinkLabel: DEFAULT_LINK_LABEL,
  Segment: getDefaultSegment(Trigger, DEFAULT_USER_TYPE),
  [SCHEDULED_FIELD_NAME]: getDefaultScheduledDate(Trigger),
})

export const saveNewOutreachMessage = (
  Scid,
  updated, // order of arguments must match all save functions
) => api.post(`/api/college/${Scid}/message`, prepareForSave(updated, Scid))

export const saveExistingOutreachMessage = (
  Scid,
  updated,
  original, // order of arguments must match all save functions
) => {
  // Making a Copy
  if (updated.Id === undefined) {
    return saveNewOutreachMessage(Scid, updated)
  } else {
    return api.patch(`/api/college/${Scid}/message/${updated.Id}`, original, prepareForSave(updated, Scid))
  }
}
